import Vue from 'vue';
import storage from '@npm/key-storage';
// import getUrlParams from '@/utils/getUrlParams'

function api() {
  return {
    mpcGetProfile({
      msisdn, profile, app = 'mpc', cc
    }) {
      const params = cc ? {
        app,
        cc
      } : { app };

      const options = {
        headers: {
          'content-type': 'application/json',
          'X-Authorization': ''
        },
        params
      };
      return Vue.axios.get(`/invoice/api/MpcProfile/${profile}/${msisdn || ''}`, options);
    },
    mcaAutoprofile() {
      const options = {
        headers: {
          'content-type': 'application/json',
          'X-Authorization': ''
        }
      };
      const token = storage.get('tokenIvr');
      return Vue.axios.get(`/invoice/api/MpcProfile/GetProfileFromMca?t=${token}`, options);
    },
    // GetInvoices
    mpcGetInvoices() {
      const options = {
        headers: {
          'content-type': 'application/json',
          Authorization: `Bearer ${storage.get('tokenIvr')}`,
          'X-Authorization': `Bearer ${storage.get('tokenIvr')}`
        }
      };
      return Vue.axios.get('/invoice/api/MpcInvoice', options);
    },
    mcwGetInvoices() {
      const options = {
        headers: {
          'content-type': 'application/json',
          Authorization: `Bearer ${storage.get('tokenMCW')}`,
          'X-Authorization': `Bearer ${storage.get('tokenMCW')}`
        }
      };
      return Vue.axios.get('/invoice/api/McwInvoice/', options);
    },
    // PaymentStatus
    paymentStatus(ccpid, app) {
      let token = '';
      if (app === 'McwInvoice') {
        token = storage.get('tokenMCW');
      } else {
        token = storage.get('tokenIvr');
      }
      const options = {
        headers: {
          'content-type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      };
      return Vue.axios.get(`/invoice/api/${app}/Payment/Status/${ccpid}`, options);
    },
    // Payments
    mpcPostPayment(paymentObject) {
      const options = {
        headers: {
          'content-type': 'application/json',
          Authorization: `Bearer ${storage.get('tokenIvr')}`
        }
      };
      return Vue.axios.post('/invoice/api/MpcInvoice/Payment', paymentObject, options);
    },
    mpcPostPaymentClave(paymentObject) {
      const options = {
        headers: {
          'content-type': 'application/json',
          Authorization: `Bearer ${storage.get('tokenIvr')}`,
          'X-Authorization': `Bearer ${storage.get('tokenIvr')}`
        }
      };
      return Vue.axios.post('/invoice/api/MpcInvoice/clavePayment', paymentObject, options);
    },
    mpcPostPaymentBitcoin(paymentObject) {
      const options = {
        headers: {
          'content-type': 'application/json',
          Authorization: `Bearer ${storage.get('tokenIvr')}`,
          'X-Authorization': `Bearer ${storage.get('tokenIvr')}`
        }
      };
      return Vue.axios.post('/invoice/api/MpcInvoice/BtcPayment', paymentObject, options);
    },
    mcwPostPayment(paymentObject) {
      const options = {
        headers: {
          'content-type': 'application/json',
          Authorization: `Bearer ${storage.get('tokenMCW')}`,
          'X-Authorization': `Bearer ${storage.get('tokenMCW')}`,
          isStage: 'true',
          'is-stage': 'true'
        }
      };
      return Vue.axios.post('/invoice/api/McwInvoice/Payment', paymentObject, options);
    },
    updateRecurringPaymentNotificationMsisdn(creditCardPaymentId, notificationMsisdn, app) {
      let token = storage.get('tokenIvr');
      if (app === 'McwInvoice') {
        token = storage.get('tokenMCW');
      }
      const options = {
        headers: {
          'content-type': 'application/json',
          Authorization: `Bearer ${token}`,
          'X-Authorization': `Bearer ${token}`
        }
      };
      return Vue.axios.get(`/invoice/api/${app}/Payment/UpdateRecurringPaymentNotificationMsisdn/${creditCardPaymentId}/${notificationMsisdn}`, options);
    },
    // Recurrence
    getInvoicesWithRecurrence() {
      const options = {
        headers: {
          'content-type': 'application/json',
          Authorization: `Bearer ${storage.get('tokenIvr')}`,
          'X-Authorization': `Bearer ${storage.get('tokenIvr')}`
        }
      };

      return Vue.axios.get('/invoice/api/MpcInvoice/GetInvoicesWithRecurrence/', options);
    },
    getCreateRecurringPayment() {
      const options = {
        headers: {
          'content-type': 'application/json',
          Authorization: `Bearer ${storage.get('tokenIvr')}`,
          'X-Authorization': `Bearer ${storage.get('tokenIvr')}`
        }
      };

      return Vue.axios.get('/invoice/api/RecurringPaymentRegistration/CreateRecurringPayment', options);
    },
    mpcUpdateRecurrence() {
      const options = {
        headers: {
          'content-type': 'application/json',
          Authorization: `Bearer ${storage.get('tokenIvr')}`,
          'X-Authorization': `Bearer ${storage.get('tokenIvr')}`
        }
      };
      return Vue.axios.get('/invoice/api/MpcRecurringPaymentActions/ChangeDataInRecurringPayment', options);
    },
    mpcCancelRecurrence() {
      const options = {
        headers: {
          'content-type': 'application/json',
          Authorization: `Bearer ${storage.get('tokenIvr')}`,
          'X-Authorization': `Bearer ${storage.get('tokenIvr')}`
        }
      };
      return Vue.axios.get('/invoice/api/RecurringPaymentCancellation/CancelRecurringPayment', options);
    },
    mpcRecurrenceSendPin() {
      const options = {
        headers: {
          'content-type': 'application/json',
          Authorization: `Bearer ${storage.get('tokenIvr')}`,
          'X-Authorization': `Bearer ${storage.get('tokenIvr')}`
        }
      };
      return Vue.axios.get('/invoice/api/RecurringPaymentRegistration/SendPin', options);
    },
    mpcRecurrenceConfirmPin(pin) {
      const options = {
        headers: {
          'content-type': 'application/json',
          Authorization: `Bearer ${storage.get('tokenIvr')}`,
          'X-Authorization': `Bearer ${storage.get('tokenIvr')}`
        }
      };
      return Vue.axios.get(`/invoice/api/RecurringPaymentRegistration/ConfirmPin/${pin}`, options);
    },
    // CardUpdate
    mpcCardUpdate(paymentObject) {
      const options = {
        headers: {
          'content-type': 'application/json',
          Authorization: `Bearer ${storage.get('tokenIvr')}`,
          'X-Authorization': `Bearer ${storage.get('tokenIvr')}`
        }
      };
      return Vue.axios.post('/invoice/api/MpcRecurringPayment/CardUpdate', paymentObject, options);
    },
    mcwCardUpdate() {
      const options = {
        headers: {
          'content-type': 'application/json',
          Authorization: `Bearer ${storage.get('tokenRecurrentInvoices')}`,
          'X-Authorization': `Bearer ${storage.get('tokenRecurrentInvoices')}`
        }
      };
      return Vue.axios.post('/invoice/api/McwRecurringPayment/CardUpdate', {}, options);
    },
    mpcUpdateEmail(notificationEmail) {
      const body = {
        notificationEmail
      };
      const options = {
        headers: {
          'content-type': 'application/json',
          Authorization: `Bearer ${storage.get('tokenIvr')}`,
          'X-Authorization': `Bearer ${storage.get('tokenIvr')}`
        }
      };
      return Vue.axios.post('/invoice/api/MpcRecurringPayment/NotificationData', body, options);
    },
    mpcUpdateEmailValidator(pin) {
      const options = {
        headers: {
          'content-type': 'application/json',
          Authorization: `Bearer ${storage.get('tokenIvr')}`,
          'X-Authorization': `Bearer ${storage.get('tokenIvr')}`
        }
      };
      return Vue.axios.get(`/invoice/api/MpcRecurringPayment/NotificationData/ConfirmPin/${pin}`, options);
    },
    mpcNotificationDataUpdate(notificationMsisdn, notificationEmail, operationToken) {
      const options = {
        headers: {
          'content-type': 'application/json',
          Authorization: `Bearer ${storage.get('tokenIvr')}`,
          'X-Authorization': `Bearer ${storage.get('tokenIvr')}`
        }
      };
      const body = {
        notificationMsisdn,
        notificationEmail,
        operationToken
      };
      return Vue.axios.post('/invoice/api/MpcRecurringPayment/NotificationData/Update', body, options);
    },
    // MCW Recurrent Invoices
    mcwCreateRecurrentPaymentInfo(serviceId, lineOfBusiness) {
      const options = {
        headers: {
          'content-type': 'application/json',
          Authorization: `Bearer ${storage.get('tokenRecurrentInvoices')}`,
          'X-Authorization': `Bearer ${storage.get('tokenRecurrentInvoices')}`
        }
      };
      const body = {
        serviceId,
        lineOfBusiness
      };
      return Vue.axios.post('/invoice/api/McwRecurringPayment/Info/CreateRecurringPayment', body, options);
    },
    mcwGetRecurrenceInvoices() {
      const options = {
        headers: {
          'content-type': 'application/json',
          Authorization: `Bearer ${storage.get('tokenRecurrentInvoices')}`,
          'X-Authorization': `Bearer ${storage.get('tokenRecurrentInvoices')}`
        }
      };
      return Vue.axios.get('/invoice/api/McwRecurringPayment/Info', options);
    },
    mcwSendRecurringPaymentCancellationMessage(serviceId, lineOfBusiness) {
      const options = {
        headers: {
          'content-type': 'application/json',
          Authorization: `Bearer ${storage.get('tokenRecurrentInvoices')}`,
          'X-Authorization': `Bearer ${storage.get('tokenRecurrentInvoices')}`
        }
      };
      return Vue.axios.get(`/invoice/api/McwRecurringPayment/Info/CancelRecurringPayment/${serviceId}/${lineOfBusiness}`, options);
    },
    mcwDdataNotificationIframeUpdate(clientId, lineOfBusiness) {
      const options = {
        headers: {
          'content-type': 'application/json',
          Authorization: `Bearer ${storage.get('tokenRecurrentInvoices')}`,
          'X-Authorization': `Bearer ${storage.get('tokenRecurrentInvoices')}`
        }
      };
      return Vue.axios.get(`/invoice/api/McwRecurringPayment/Info/NotificationDataUpdate/${clientId}/${lineOfBusiness}`, options);
    },
    mpcUsaSms({ claroServiceId, usaMsisdn, name }) {
      const body = {
        claroServiceId,
        usaMsisdn,
        name
      };
      return Vue.axios.post('/invoice/api/MpcUsaSms/SendUsaMessage', body);
    }
  };
}

export default api;
